{
  "navigation": {
    "products": "Nuestros productos",
    "pricing": "Tarifas",
    "testimonials": "Opiniones",
    "blog": "Blog",
    "freeQuote": "Presupuesto gratis",
    "tagline": "Creador de recuerdos"
  },
  "header": {
    "title": "Crea tu Yearbook de moda",
    "subtitle": "Reúne, cuenta, revive.",
    "description": "Inmortaliza este año escolar en un libro de fotos personalizado, creado por ti. Un concentrado de recuerdos, risas y emociones, para guardar con cariño o regalar.",
    "formTitle": "Obtén tu presupuesto gratis",
    "formName": "Nombre",
    "formEmail": "Email",
    "formPhone": "Teléfono",
    "formOrganization": "Centro educativo",
    "formSubmit": "Obtener mi presupuesto",
    "formSubmitting": "Enviando...",
    "formMessage": "Describe tu proyecto...",
    "formQuoteDelay": "(Presupuesto en menos de 24h)",
    "downloadEbook": "Descarga nuestro ebook gratis",
    "partnerSchools": "Escuelas asociadas",
    "madeInFrance": "Made in France",
    "counters": {
      "yearbooks": "yearbooks ya creados",
      "satisfaction": "de clientes satisfechos",
      "years": "años de experiencia"
    }
  },
  "services": {
    "title": "Crea tu yearbook en 3 pasos",
    "subtitle": "Transforma tus recuerdos en un libro único.",
    "subtitleBreak": "Simple, rápido y personalizado.",
    "step1": {
      "title": "Elige",
      "description": "Selecciona tu fórmula y personaliza tu yearbook según tus deseos"
    },
    "step2": {
      "title": "Sube",
      "description": "Importa tus fotos y deja que la magia suceda con nuestro editor intuitivo"
    },
    "step3": {
      "title": "Recibe",
      "description": "Recibe tus yearbooks impresos directamente en tu centro"
    },
    "learnMore": "Más información sobre el proceso"
  },
  "products": {
    "title": "Descubre nuestros Yearbooks",
    "subtitle": "Formatos adaptados a todos los presupuestos, desde infantil hasta universidad.",
    "from": "Desde",
    "perUnit": "/ unidad",
    "details": "Ver detalles",
    "popular": "Popular",
    "degressivePricing": "Se aplican tarifas decrecientes según la cantidad.",
    "miniBudget": {
      "title": "Mini-Presupuesto",
      "subtitle": "Para escuelas e institutos",
      "description": "Lo esencial para guardar tus recuerdos"
    },
    "classic": {
      "title": "Clásico",
      "subtitle": "Para universidades",
      "description": "La mejor relación calidad-precio"
    },
    "premium": {
      "title": "Premium",
      "subtitle": "Para asociaciones y empresas",
      "description": "Para recuerdos excepcionales"
    },
    "features": {
      "pages20to32": "De 20 a 32 páginas",
      "stapled": "Grapado",
      "priceFor150": "Precio indicado para un pedido de 150 ejemplares",
      "from36pages": "A partir de 48 páginas",
      "softCover": "Tapa blanda",
      "squareBack": "Lomo cuadrado encolado",
      "from32pages": "A partir de 32 páginas",
      "hardCover": "Tapa dura cartoné"
    }
  },
  "pricing": {
    "title": "¡Un acompañamiento creativo a medida!",
    "subtitle": "Fórmulas de diseño claras, adaptadas a todos según el acompañamiento creativo deseado.",
    "evolveOffer": "¡Puedes cambiar tu oferta durante el proyecto!",
    "bestSeller": "Más vendido",
    "essential": {
      "name": "Esencial",
      "subtitle": "¡Tu Yearbook\nen pocos clics! 💪",
      "description": "¡Una plataforma intuitiva y rica en diseño para tu creatividad!",
      "price": "Gratis"
    },
    "serenity": {
      "name": "Serenidad",
      "subtitle": "Un Yearbook perfecto con la ayuda de nuestros expertos Diseñadores 🧑‍🎨",
      "description": "¡Un acompañamiento gráfico profundo con nuestros expertos en diseño!",
      "price": "450€"
    },
    "custom": {
      "name": "A medida",
      "subtitle": "Un Yearbook a medida según tus deseos 🎨",
      "description": "¡La creación de tu Yearbook\nde la A a la Z por nuestros expertos!",
      "price": "1150€"
    },
    "features": {
      "followUp": "Acompañamiento Seguimiento",
      "editor": "Editor Yearbook",
      "designsStickers": "(+250 diseños y 1500 stickers)",
      "graphistExchanges": "Intercambio(s) con diseñadores",
      "digitalYearbook": "Yearbook Digital",
      "customCreation": "Creación a medida",
      "cover": "Portada",
      "interior": "Interior",
      "trombi": "Orla",
      "bonusUpload": "Bonus: Subida de tus contenidos",
      "yes": "Sí",
      "no": "No"
    },
    "chooseFormula": "Elegir esta fórmula"
  },
  "demos": {
    "title": "Nuestros ejemplos",
    "titleHighlight": "de creaciones",
    "subtitle": "Descubre nuestras creaciones para cada nivel escolar.",
    "viewYearbook": "Ver el yearbook",
    "filters": {
      "all": "Todos",
      "primary": "Primaria",
      "middle": "Secundaria",
      "high": "Bachillerato",
      "university": "Universidad"
    }
  },
  "testimonials": {
    "title": "Confían en nosotros",
    "subtitle": "Descubre los testimonios de nuestros clientes satisfechos.",
    "whatTheySay": "Lo que dicen de nosotros",
    "clientTypes": {
      "engineeringSchool": "Escuela de ingeniería",
      "businessSchool": "Escuela de negocios",
      "europeanSchool": "Escuela europea",
      "internationalSchool": "Escuela internacional",
      "establishment": "Centro educativo",
      "citySchool": "Colegio Municipal",
      "school": "Escuela",
      "politicalScience": "Escuela de ciencias políticas",
      "midwiferySchool": "Escuela de matronas",
      "universityInstitute": "Instituto universitario",
      "managementSchool": "Escuela de gestión",
      "company": "Empresa",
      "foundation": "Fundación",
      "event": "Evento",
      "hospitality": "Hostelería",
      "fashion": "Moda",
      "union": "Sindicato"
    }
  },
  "team": {
    "title": "Nuestro equipo",
    "subtitle": "Un equipo comprometido y siempre a tu escucha.",
    "members": {
      "hubert": {
        "role": "Fundador",
        "description": "Hubert, emprendedor apasionado, fundó 1Year1Book en Francia con el sueño de democratizar el mundo de los Yearbooks y crear recuerdos inolvidables."
      },
      "lynda": {
        "role": "Equipo Comercial",
        "description": "Lynda te acompaña con amabilidad en la realización de tus proyectos Yearbook. Atenta a tus necesidades, hace todo lo posible para garantizar su éxito."
      },
      "charlotteB": {
        "role": "Equipo Comunicación",
        "description": "Creativa, Shaima desarrolla nuestra imagen de marca estableciendo asociaciones estratégicas para aumentar nuestra visibilidad, mientras crea contenido que valoriza plenamente el Yearbook."
      },
      "raphaelle": {
        "role": "Equipo Relación Cliente",
        "description": "Atenta y reactiva, Raphaëlle te garantiza una experiencia cliente excepcional en cada etapa de tu proyecto."
      },
      "charlotteR": {
        "role": "Equipo Diseño",
        "description": "Charlotte propone diseños únicos que transforman cada Yearbook en una obra de arte personalizada."
      },
      "cedric": {
        "role": "Equipo Tech",
        "description": "Es el experto técnico de 1Year1Book. Cédric se asegura de que estemos a la vanguardia de la tecnología para siempre ofrecerte soluciones modernas e innovadoras."
      }
    }
  },
  "yearbookGallery": {
    "title": "¡Yearbooks para todos!",
    "subtitle": "Explora nuestros ejemplos inspiradores, adaptados a todas las edades y ocasiones.",
    "viewCatalogue": "Ver nuestro catálogo",
    "categories": {
      "primary": "Escuelas Primarias",
      "middle": "Colegios Secundarios",
      "high": "Institutos",
      "university": "Universidades y Grandes Escuelas",
      "leisureCenter": "Centros de ocio",
      "camps": "Campamentos de verano"
    },
    "categoryDescriptions": {
      "primary": "Yearbooks especialmente diseñados para escuelas primarias con diseños coloridos y lúdicos.",
      "middle": "Yearbooks modernos adaptados a estudiantes de secundaria con diseños dinámicos.",
      "high": "Yearbooks elegantes para inmortalizar los años de bachillerato con estilo.",
      "university": "Yearbooks profesionales para grandes escuelas y universidades.",
      "leisureCenter": "Yearbooks divertidos y coloridos para centros de ocio y actividades extraescolares.",
      "camps": "Recuerdos inolvidables de los campamentos de verano en un formato único."
    },
    "features": {
      "childDesign": "Diseño adaptado a niños",
      "colorfulPages": "Páginas coloridas",
      "resistantFormat": "Formato resistente",
      "activitiesIncluded": "Actividades incluidas",
      "modernLayout": "Diseño moderno",
      "classPhotos": "Fotos de clase",
      "socialPages": "Páginas de redes sociales",
      "activitiesSection": "Sección de actividades",
      "elegantDesign": "Diseño elegante",
      "seniorYear": "Último año",
      "promSection": "Sección de graduación",
      "alumniDirectory": "Directorio de antiguos alumnos",
      "professionalFormat": "Formato profesional",
      "alumniSection": "Sección alumni",
      "careerPages": "Páginas de carreras",
      "eventCoverage": "Cobertura de eventos",
      "funDesign": "Diseño divertido",
      "activityPhotos": "Fotos de actividades",
      "groupPages": "Páginas de grupo",
      "memoriesSection": "Sección de recuerdos",
      "adventureDesign": "Diseño aventura",
      "campPhotos": "Fotos de campamento",
      "adventurePages": "Páginas de aventuras",
      "friendsSection": "Sección de amigos"
    }
  },
  "footer": {
    "contactForm": "Formulario de contacto",
    "launchNow": "¡Empieza ahora!",
    "name": "Nombre",
    "email": "Email",
    "phone": "Teléfono",
    "message": "Mensaje",
    "send": "Enviar",
    "sending": "Enviando...",
    "contactInfo": "Nuestros datos de contacto",
    "address": "Dirección",
    "followUs": "Síguenos",
    "hours": "Horarios",
    "hoursValue": "Lun - Vie: 9h - 18h",
    "weekendClosed": "Sábado / Domingo",
    "closed": "Cerrado",
    "legalLinks": "Enlaces legales",
    "legalNotice": "Aviso legal",
    "privacy": "Política de privacidad",
    "terms": "Condiciones generales",
    "faq": "FAQ",
    "copyright": "Todos los derechos reservados."
  },
  "common": {
    "loading": "Cargando...",
    "error": "Error",
    "success": "Éxito",
    "close": "Cerrar",
    "submit": "Enviar",
    "cancel": "Cancelar",
    "previous": "Anterior",
    "next": "Siguiente",
    "fillRequired": "Por favor, rellena todos los campos obligatorios."
  },
  "thankYou": {
    "title": "¡Gracias!",
    "message": "Tu solicitud ha sido enviada con éxito. Te contactaremos lo antes posible."
  },
  "quote": {
    "title": "Solicitud de presupuesto",
    "selectFormula": "Selecciona una fórmula",
    "quantity": "Número estimado de ejemplares",
    "establishment": "Centro educativo",
    "level": "Nivel escolar",
    "levels": {
      "primary": "Primaria",
      "middle": "Secundaria",
      "high": "Bachillerato",
      "university": "Universidad",
      "other": "Otro"
    }
  },
  "cse": {
    "solutionBadge": "Solución CSE",
    "heroTitle": "El BAI – Balance de Actividades Individual",
    "heroDescription": "1Year1Book acompaña a los CSE en la creación de su BAI, un documento personalizado entregado a cada empleado para valorizar las ventajas concedidas.",
    "launchButton": "¡Empieza!",
    "baiDistributed": "BAI distribuidos",
    "whatIsBai": "¿Qué es el BAI?",
    "whatIsBaiDescription": "El BAI sintetiza, de manera clara, gráfica y cifrada, el conjunto de ventajas concedidas por el CSE durante un año:",
    "baiCategories": {
      "leisureCulture": "Ocio y cultura",
      "vacationsTravel": "Vacaciones y viajes",
      "socialAid": "Ayudas sociales",
      "internalEvents": "Eventos internos",
      "catering": "Restauración",
      "sportsWellness": "Deporte y bienestar"
    },
    "whyChooseBai": "¿Por qué elegir el BAI?",
    "whyChooseBaiSubtitle": "La mejor herramienta de comunicación del CSE para valorizar su trabajo, reforzar la transparencia y la adhesión de los empleados",
    "benefits": {
      "personalizedDocument": "Documento personalizado",
      "personalizedDocumentDesc": "Cada empleado recibe su propio balance con sus datos individuales",
      "clearVisualization": "Visualización clara",
      "clearVisualizationDesc": "Gráficos y cifras para una lectura inmediata de las ventajas",
      "benefitsHighlight": "Valorización de las ventajas",
      "benefitsHighlightDesc": "Puesta en valor concreta del poder adquisitivo ganado",
      "totalTransparency": "Transparencia total",
      "totalTransparencyDesc": "Refuerza la confianza y la comprensión de las acciones del CSE",
      "electoralTool": "Herramienta electoral poderosa",
      "electoralToolDesc": "Valoriza el trabajo realizado y refuerza la adhesión de los empleados"
    },
    "howItWorks": "¿Cómo funciona?",
    "howItWorksSubtitle": "Un proceso simple y eficaz para valorizar tus acciones CSE",
    "steps": {
      "step1": "Transmisión de datos",
      "step1Desc": "Nos transmites los datos de las ventajas por empleado de manera segura",
      "step2": "Creación de los BAI",
      "step2Desc": "Creamos los balances personalizados con tus colores e identidad visual",
      "step3": "Distribución",
      "step3Desc": "Cada empleado recibe su BAI impreso o en formato digital"
    },
    "theyTrustUs": "Confían en nosotros",
    "theyTrustUsSubtitle": "Empresas de renombre confían en nosotros para valorizar sus acciones CSE",
    "ctaTitle": "¿Listo para valorizar tus acciones CSE?",
    "ctaSubtitle": "Contáctanos para descubrir cómo el BAI puede transformar la comunicación",
    "ctaSubtitle2": "con tus empleados",
    "footerCopyright": "© 2025 1Year1Book SAS - Todos los derechos reservados",
    "banner": {
      "powerfulTool": "Herramienta de comunicación muy poderosa",
      "optimalCommunication": "Comunicación óptima con los empleados",
      "cseWorkValorization": "Valorización del trabajo del CSE",
      "teamAdhesion": "Refuerzo de la adhesión de los equipos",
      "totalTransparency": "Transparencia total de las ventajas"
    },
    "dialog": {
      "title": "¡Empieza!",
      "description": "Rellena este formulario y nuestro equipo te contactará para crear tu BAI personalizado.",
      "nameLabel": "Nombre / Apellido *",
      "namePlaceholder": "Juan García",
      "organizationLabel": "Organización *",
      "organizationPlaceholder": "CSE de tu empresa",
      "phoneLabel": "Teléfono",
      "phonePlaceholder": "+34 612 345 678",
      "emailLabel": "Email *",
      "emailPlaceholder": "juan.garcia@empresa.es",
      "submitButton": "Enviar mi solicitud",
      "submitting": "Enviando...",
      "thankYouTitle": "¡Gracias!",
      "thankYouMessage": "Tu solicitud ha sido enviada con éxito. Nuestro equipo te contactará muy pronto.",
      "closeButton": "Cerrar",
      "errorRequired": "Por favor, rellena todos los campos obligatorios.",
      "errorSend": "Ha ocurrido un error al enviar. Por favor, inténtalo de nuevo."
    }
  },
  "ambassadors": {
    "badge": "Programa Embajadores",
    "heroTitle": "Conviértete en Embajador 1Year1Book",
    "heroDescription": "Abre puertas gracias a tu red y gana una comisión atractiva en cada proyecto Yearbook. Cero restricciones operativas.",
    "becomeAmbassador": "Convertirse en embajador",
    "missionBadge1": "Misión 1",
    "missionBadge2": "Misión 2",
    "missionsTitle": "Tus misiones principales",
    "missionsSubtitle": "Un rol de iniciador, sin carga operativa: ni venta, ni negociación, ni producción, ni seguimiento.",
    "seeList": "Ver la lista",
    "schoolsListTitle": "Centros fuera de la red de socios",
    "missions": {
      "identify": {
        "title": "Identificar",
        "description": "Contacta con centros fuera de nuestra red de socios que puedan estar interesados en un Yearbook."
      },
      "detect": {
        "title": "Detectar",
        "description": "Detecta un proyecto Yearbook real y estructurado para el año en curso o el próximo."
      },
      "connect": {
        "title": "Conectar",
        "description": "Transmite el contacto cualificado a nuestro equipo que tomará el relevo."
      }
    },
    "whatYouDoTitle": "Lo que haces concretamente",
    "whatYouDoSubtitle": "Un proceso simple en 4 pasos",
    "steps": {
      "contact": {
        "title": "Haz contacto",
        "description": "Contacta con el centro de tu red"
      },
      "present": {
        "title": "Presenta el concepto",
        "description": "Explica brevemente el Yearbook"
      },
      "verify": {
        "title": "Verifica los criterios",
        "description": "Interés real, proyecto estructurado, mín. 50 ejemplares"
      },
      "transmit": {
        "title": "Transmítenos",
        "description": "Envía el contacto cualificado a nuestro equipo"
      }
    },
    "noSaleNegotiation": "No intervienes ni en la venta, ni en la negociación, ni en la producción",
    "remunerationBadge": "Remuneración atractiva",
    "remunerationTitle": "Una comisión progresiva según tus resultados",
    "remunerationDescription": "Cuantos más proyectos aportes, mayor será tu tasa de comisión. Un sistema transparente y motivador.",
    "minimum50": "Mínimo 50 ejemplares por contrato",
    "basedOnOrders": "Cálculo basado en los ejemplares pedidos y pagados",
    "paymentAfterSignature": "Pago en 30 días tras validación",
    "whyBecomeTitle": "¿Por qué convertirse en embajador?",
    "why": {
      "simple": {
        "title": "Un rol simple",
        "description": "Abres puertas gracias a tu red. Nosotros gestionamos todo lo demás."
      },
      "transparent": {
        "title": "Remuneración transparente",
        "description": "Comisión clara y pagada después de cada proyecto validado y pagado."
      },
      "noConstraint": {
        "title": "Cero restricciones",
        "description": "Sin negociaciones, sin seguimiento de proyecto, sin producción que gestionar."
      },
      "humanValue": {
        "title": "Proyecto de alto valor humano",
        "description": "Recuerdo inolvidable para los estudiantes, impacto emocional duradero."
      }
    },
    "weHandleTitle": "Lo que nos encargamos",
    "weHandleSubtitle": "Una vez hecha la conexión, nuestro equipo gestiona todo el proyecto.",
    "weHandle": {
      "structuring": "La estructuración precisa de la necesidad",
      "proposal": "La propuesta comercial y contractual",
      "coordination": "La coordinación con el centro",
      "design": "El diseño, la producción y la entrega"
    },
    "validConditionsTitle": "Condiciones de validación",
    "validConditionsSubtitle": "Un lead se considera válido si:",
    "conditions": {
      "notPartner": "El centro no es ya socio",
      "newContact": "El contacto transmitido es nuevo",
      "signedContract": "El proyecto resulta en un contrato firmado",
      "minimum50": "El pedido alcanza al menos 50 ejemplares"
    },
    "contactTitle": "Únete al programa",
    "contactSubtitle": "Rellena el formulario y nuestro equipo te contactará",
    "form": {
      "name": "Nombre completo",
      "namePlaceholder": "Juan García",
      "email": "Email",
      "emailPlaceholder": "juan.garcia@email.com",
      "phone": "Teléfono (opcional)",
      "phonePlaceholder": "+34 612 345 678",
      "message": "Mensaje (opcional)",
      "messagePlaceholder": "Cuéntanos sobre tu red o haz tus preguntas...",
      "submit": "Enviar mi candidatura",
      "successTitle": "¡Candidatura enviada!",
      "successMessage": "Gracias por tu interés. Nuestro equipo te contactará muy pronto."
    },
    "footerRights": "Todos los derechos reservados",
    "banner": {
      "simpleRole": "Rol simple y gratificante",
      "attractiveRemuneration": "Remuneración atractiva",
      "zeroConstraint": "Cero restricciones operativas",
      "humanProject": "Proyecto de alto valor humano",
      "networkOpportunity": "Oportunidad de red"
    }
  }
}
